import { Link } from 'react-router-dom';
import PolicyLayout, {
  PolicyContact,
  PolicyList,
  PolicySection,
  PolicySubsection,
} from '../components/PolicyLayout';
import { COMPANY_NAME, SITE_DOMAIN, SITE_NAME, SITE_URL } from '../constants/site';

const UPDATED = 'May 25, 2026';

export default function AdvertiserDisclosurePage() {
  return (
    <PolicyLayout title="Advertiser Disclosure" lastUpdated={UPDATED}>
      <PolicySection title="1. Transparency statement">
        <p>
          {SITE_NAME} ({SITE_URL}) is operated by {COMPANY_NAME}. We believe in clear disclosure of how our website earns
          revenue and how search results are ordered. This page explains relationships with advertisers, suppliers, and
          marketing partners.
        </p>
      </PolicySection>

      <PolicySection title="2. How we earn revenue">
        <PolicyList
          items={[
            'Service or agency fees charged at booking, disclosed during checkout when applicable.',
            'Commissions paid by airlines, hotels, car rental companies, cruise lines, and package providers when you complete a purchase.',
            'Advertising and sponsored placement fees from partners featured in banners, emails, or promotional modules.',
            'Affiliate or referral compensation when you click certain links and complete qualifying transactions.',
          ]}
        />
      </PolicySection>

      <PolicySection title="3. Search results and sort order">
        <p>
          Search results may be sorted by price, duration, departure time, or relevance. In some views, offers from
          partners who compensate us may receive preferred placement when clearly labeled as sponsored or featured.
          Sponsored placement does not change the total price you pay unless a promotion explicitly states otherwise.
        </p>
      </PolicySection>

      <PolicySection title="4. Editorial content">
        <p>
          Destination guides, deal highlights, and marketing copy on {SITE_DOMAIN} are for informational purposes. They
          are not independent journalistic reviews unless explicitly attributed to a third-party publication. Prices in
          marketing content are illustrative and may differ from live search results.
        </p>
      </PolicySection>

      <PolicySection title="5. Third-party links and offers">
        <p>
          Our site may link to external websites, payment providers, and loyalty programs. Those sites have their own
          privacy practices and terms. We are not responsible for products or services purchased outside {SITE_NAME}.
        </p>
      </PolicySection>

      <PolicySection title="6. Testimonials and reviews">
        <p>
          Customer testimonials displayed on the site represent individual experiences and may not reflect typical
          outcomes. Where reviews are aggregated from verified purchasers, we indicate the source. We do not pay for
          false or misleading reviews.
        </p>
      </PolicySection>

      <PolicySection title="7. Advertising partners">
        <PolicySubsection title="7.1 Display advertising">
          <p>
            We may use ad networks that set cookies or pixels to measure campaign performance. See our{' '}
            <Link to="/flight/cookies">Cookie Policy</Link> for controls.
          </p>
        </PolicySubsection>
        <PolicySubsection title="7.2 Email and retargeting">
          <p>
            With your consent, we may send promotional emails or show retargeting ads based on pages you viewed. You can
            unsubscribe from marketing emails at any time.
          </p>
        </PolicySubsection>
      </PolicySection>

      <PolicySection title="8. No endorsement">
        <p>
          Display of a supplier, airline, or hotel brand does not constitute an endorsement. All suppliers are independent
          businesses responsible for their own performance and compliance with law.
        </p>
      </PolicySection>

      <PolicySection title="9. Contact us">
        <p>
          Questions about advertising or partnerships? See <Link to="/flight/privacy">Privacy Policy</Link> for data practices
          or contact us below.
        </p>
        <PolicyContact />
      </PolicySection>
    </PolicyLayout>
  );
}
